<template>
	<div class="column-input block-editor-inputs-layout">
		<div class="prefix-icons">
			<ColumnSvg />
		</div>
		<!-- pass $attrs to child means pass all attributes of component that arent explicit declare as props -->
		<RichTextBox v-on="$listeners" v-bind="$attrs" readonly :ref="RICH_EDITOR_REFERENCE_NAME" />
		<div class="suffix-icons" v-if="!readonly">
			<span @click="$emit('click')">
				<DropdownArrowSvg class="dropdown-icon" :class="{ 'dropdown-open': isDropdownOpen }" />
			</span>
		</div>
	</div>
</template>

<script>
import ColumnSvg from './assets/ColumnSvg';
import DropdownArrowSvg from './assets/DropdownArrowSvg';
import InputComponentMixinBase from './mixins/InputComponentMixinBase';
export default {
	name: 'TableColumnDropdownInput',
	props: {
		isDropdownOpen: { type: Boolean },
		readonly: { type: Boolean },
	},
	mixins: [InputComponentMixinBase],
	components: { ColumnSvg, DropdownArrowSvg },
};
</script>
<style lang="scss" scoped>
.column-input {
	@import '../block-editor-inputs-layout.scss';
}
</style>
